import {commonConstants} from '../_constants';
import { initialState } from '../_helpers';

export function users(state=initialState.users, action) {
    switch (action.type) {
        case commonConstants.USERS_SUCCESS:
            return Object.assign({}, state, action.users);
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/user.reducer.js